import { t } from "@lingui/macro";
import cx from "classnames";

import * as React from "react";
import { useDispatch } from "react-redux";
import { ModalWrapper } from "../../../components/ModalWrapper";
import { Offer } from "../../../interfaces/resources/offer";
import { deleteOfferAction } from "../../../services/api/offer/actions";
import globalStyles from "../../../styles/global.module.scss";
import styles from "./index.module.scss";

interface Props {
  offer: Offer;
  onCloseModal: () => void;
}

interface CtaProps {
  offer: Offer;
  className?: string;
}

export const DeleteOfferModalCta: React.FC<CtaProps> = (props: CtaProps) => {
  const { offer, className = "" } = props;
  const [openModal, setOpenModal] = React.useState(false);
  const closeModal = () => {
    setOpenModal(false);
  };
  return (
    <>
      <button
        type="button"
        className={cx(className, globalStyles.cta, globalStyles.alertCta)}
        onClick={() => {
          setOpenModal(true);
        }}
      >
        {t`Constant.delete`}
      </button>
      <ModalWrapper open={openModal} onCloseModal={closeModal}>
        <DeleteOfferModal offer={offer} onCloseModal={closeModal} />
      </ModalWrapper>
    </>
  );
};

export const DeleteOfferModal: React.FC<Props> = (props: Props) => {
  const { offer, onCloseModal } = props;
  const dispatch = useDispatch();

  const closeModal = () => {
    if (typeof onCloseModal === "function") {
      onCloseModal();
    }
  };

  const onConfirmation = () => {
    dispatch(deleteOfferAction(offer["@id"]));
    closeModal();
  };

  return (
    <div className={styles.modal}>
      <div className={styles.container}>
        <div className={styles.titleContainer}>
          <h3 className={styles.title}>{t`offerDelete.confirm.header`}</h3>
        </div>
        <div>
          <p className={styles.text}>{t`offerDelete.confirm.content`}</p>
        </div>
        <div className={styles.ctaListContainer}>
          <div>
            <button
              type="button"
              onClick={closeModal}
              className={cx(globalStyles.cta, globalStyles.darkCta, globalStyles.inverted)}
            >
              {t`Constant.cancel`}
            </button>
          </div>
          <div>
            <button type="button" className={cx(globalStyles.cta, globalStyles.alertCta)} onClick={onConfirmation}>
              {t`Constant.confirm`}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
